// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"6b61913e","575":"2e95d071","589":"a12b3243","730":"ed74fd9b"}[chunkId] + ".chunk.js";
};